# ------------------------------------*|
#     #api.webform service
# ------------------------------------*|

moduleWebForm = angular.module 'api.webform', []

moduleWebForm.factory 'WebForm', ["Restangular", "$rootScope", "$stateParams", "$state", "$modal", "$injector", (Restangular, $rootScope, $stateParams, $state, $modal, $injector) ->
  site =
    _currentSite: Restangular.one('web_forms', $stateParams.formId)
    get: (id) ->
      if id
        Restangular.one('web_forms', id).get()
      else
        Restangular.one('web_forms', $stateParams.formId).get()
    getList: ->
      Restangular.all('web_forms').getList()
    update: (site) ->
      Restangular.all('web_forms').one(site.id).customPUT site
    updateByRoute: (site) ->
      Restangular.all('web_forms').one($stateParams.formId).customPUT site
    remove: (id) ->
      Restangular.one('web_forms', id).remove()
    create: (site) ->
      Restangular.all('web_forms').post(site)
    saveIndex: (changes) ->
      Restangular.one('web_forms', $stateParams.formId).all('assets/save').post({changes: changes, path: $rootScope.currentFile.full_path})
    transfer: (data) ->
      Restangular.one('web_forms', $stateParams.formId).all("transfer").post(data)
    share: (site) ->
      Restangular.one('web_forms', $stateParams.formId).all("share").post(site)
    setTemplate: (template_id) ->
      Restangular.all("web_forms").one($state.params.formId).customPUT template_id: template_id
    createTemplate: (templateParams) ->
      Restangular.all("web_forms").one($state.params.formId).all("templates").post(templateParams)
    # Create site modal
    addSite: ->
      $state.go "root.new_site"
    publish: ->
      Restangular.all("web_forms").one($state.params.formId).all("build").post()
    clone: (site_id) ->
      Restangular.all("web_forms").one(site_id).all("clone").post()
    # Redirect to site
    goToSite: (siteSlug) ->
      if $stateParams.formId
        if !$state.includes("public.templates") and !$state.includes("form.page.editor")
          newstate = _.extend $state.params, {formId: siteSlug}
          $state.transitionTo($state.current, newstate, {
            reload: true
          });
        else
          $state.go('root.site.requests.bystatus', {formId: siteSlug, status: "inbox"})
      else
        $state.go('root.site.requests.bystatus', {formId: siteSlug, status: "inbox"})
  site
]



// WEBPACK FOOTER //
// ./src/app/editor/api/webform.coffee